import { Link } from 'react-router';
import { Compass, FolderGit2 } from 'lucide-react';
import { RobotMark } from '../components/Logo';

export default function NotFoundPage() {
  return (
    <div className="grid min-h-[60vh] place-items-center px-4 py-10">
      <div className="flex max-w-md animate-rise flex-col items-center gap-5 text-center">
        <div className="relative">
          <RobotMark className="size-20" />
          <span className="dr-tint-secondary absolute -right-3 -bottom-2 grid size-9 place-items-center rounded-full ring-4 ring-canvas">
            <Compass className="size-4.5" aria-hidden="true" />
          </span>
        </div>
        <div className="space-y-2">
          <p className="text-sm font-semibold tracking-wide text-base-content/50 uppercase">Error 404</p>
          <h1 className="text-3xl font-bold tracking-tight">Page not found</h1>
          <p className="text-base-content/65">This address does not match any DevRobot page. The project, target or job may have been removed, or the link is mistyped.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2">
          <Link to="/" className="btn btn-primary">
            Go to the overview
          </Link>
          <Link to="/projects" className="btn btn-ghost">
            <FolderGit2 className="size-4" aria-hidden="true" />
            Browse projects
          </Link>
        </div>
      </div>
    </div>
  );
}
